import { shopPrefix } from '../../config';
import { http } from '../axios';
import { BulkAddProductsToSelectionListResponse, LineItemKey, ProductFilter } from '../../store/api';

export type CopyBulkFromSelectionListByFilterRequest = {
    filterRequest: ProductFilter;
    excludedLineItemKeys: LineItemKey[];
    sourceSelectionListId: string;
};

type Params = { performChecks: boolean };

type Options = {
    selectionListId: string;
    body: CopyBulkFromSelectionListByFilterRequest;
    params: Params;
};

const url = `${shopPrefix}/v2/selectionlists/:selectionListId/bulk/selectionlist/filter/copy`;

export const copyBulkFromListToListByFilter = ({ selectionListId, params, body }: Options) => {
    return http
        .post<BulkAddProductsToSelectionListResponse>(url, body, {
            params,
            pathParams: {
                selectionListId
            }
        })
        .then(res => res.data);
};
